import { mainApi } from "services/main";
import { GaiaConstants } from "utils";
import {
  BatchUniqueValuesRequest,
  BatchUniqueValuesResponse,
  BatchUpdateTasksRequest,
  BatchUpdateTasksResponse,
  ExportTeamTasksRequest,
  ExportTeamTasksResponse,
  GetTasksCountRequest,
  GetTasksCountResponse,
  SearchRequest,
  SearchTaskResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTasksCount: builder.query<GetTasksCountResponse, GetTasksCountRequest>({
      query: (request: GetTasksCountRequest) => ({
        url: "tasks-count",
        params: { teamName: request.teamName },
      }),
    }),
    exportTeamTasks: builder.query<
      ExportTeamTasksResponse,
      ExportTeamTasksRequest
    >({
      query: (request: ExportTeamTasksRequest) => ({
        url: "tasks-export",
        params: { teamName: request.teamName },
      }),
    }),
    searchTasks: builder.query<SearchTaskResponse, SearchRequest>({
      query: (params) => ({
        url: "/tasks-search",
        method: "POST",
        body: params,
      }),
      providesTags: ["Tasks"],
    }),
    getBatchUniqueValues: builder.query<
      BatchUniqueValuesResponse,
      BatchUniqueValuesRequest
    >({
      query: (params) => ({
        url: "/tasks-unique-values",
        method: "POST",
        body: params,
      }),
    }),
    batchUpdateTasks: builder.mutation<
      BatchUpdateTasksResponse,
      BatchUpdateTasksRequest
    >({
      query: (params) => ({
        url: "/tasks-batch-update",
        method: "PUT",
        body: params,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          setTimeout(() => {
            dispatch(mainApi.util.invalidateTags(["Tasks"]));
          }, GaiaConstants.OPENSEARCH_SYNC_DELAY);
        } catch {
          // Mutation failed; no need to invalidate cache.
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTasksCountQuery,
  useLazyExportTeamTasksQuery,
  useSearchTasksQuery,
  useLazySearchTasksQuery,
  useGetBatchUniqueValuesQuery,
  useBatchUpdateTasksMutation,
  usePrefetch,
} = extendedApi;
